import { faqItems } from '@/mocks/home';

export default function FAQSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-10">
            <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-4 whitespace-nowrap">
              快速解答
            </span>
            <h2 className="text-xl md:text-2xl font-heading text-foreground-950">常见问题</h2>
          </div>

          <div className="space-y-3">
            {faqItems.map((item) => (
              <div key={item.id} className="rounded-lg bg-background-50 border border-background-200 p-5">
                <h3 className="text-sm md:text-base font-heading text-foreground-900 mb-2">{item.question}</h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">{item.answer}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}